import ninegrid from "../index.js";

export class nxConfirmPopup extends HTMLElement
{
	constructor() {
		super();

		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		this.shadowRoot.innerHTML = `
			<nx-dialog css-file="nxConfirm.css">
				<div class="msg"></div>
				<buttons class="buttons-confirm">
					<button class="ok">Yes</button>
					<button class="cancel">No</button>
				</buttons>
			</nx-dialog>
		`;
		
		//ninegrid.j.querySelectorAll(this).addClass('roadRunner');
	}
	
	static confirm = async (message, title, options={}) => {

		title = title || 'Confirm';
		
		for (const prop in ninegrid.options.confirm) {
			options[prop] = options[prop] || ninegrid.options.confirm[prop];
		}
		
		$('nx-confirm-popup', document.body).remove();
		$(document.body).append($(`<nx-confirm-popup class="${options.class} ${options.animation}"></nx-confirm-popup>`));
		
		const t		= document.body.querySelector("nx-confirm-popup");
		const ok	= t.shadowRoot.querySelector(".ok");
		const cancel= t.shadowRoot.querySelector(".cancel");
		const close	= t.shadowRoot.querySelector(".close");
		
		$('.title', t.shadowRoot).html(title);
		$('.msg', t.shadowRoot).html(message.replaceAll("\n", "<br/>"));
		
		ok		.innerHTML = options["true-text"];
		cancel	.innerHTML = options["false-text"];
		
		return new Promise(function(resolve, reject) {
			$(ok)		.on("click", e => { resolve(true);	$(close).trigger("click"); });
			$(cancel)	.on("click", e => { resolve(false);	$(close).trigger("click"); });
			$(".close,.close2", t.shadowRoot)	.on("click", e => { resolve(); });

			t.shadowRoot.querySelector('dialog').showModal();
		});
	};
}

export class nxAlertPopup extends HTMLElement
{
	constructor() {
		super();

		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		this.shadowRoot.innerHTML = `
			<nx-dialog css-file="nxAlert.css">
				<div class="msg"></div>
				<buttons class="buttons-confirm">
					<button class="cancel">Close</button>
				</buttons>
			</nx-dialog>
		`;
		
		//ninegrid.j.querySelectorAll(this).addClass('roadRunner');
	}
	
	static alert = async (message, title="Alert", options={}) => {

		title = title || 'Alert';
		
		for (const prop in ninegrid.options.alert) {
			options[prop] = options[prop] || ninegrid.options.alert[prop];
		}
		
		$('nx-alert-popup', document.body).remove();
		$(document.body).append($(`<nx-alert-popup class="${options.class} ${options.animation}"></nx-alert-popup>`));
		
		const t		= document.body.querySelector("nx-alert-popup");
		
		$('.title', t.shadowRoot).html(title);

		//console.log(message);

		//$('.msg', t.shadowRoot).html(message?.replaceAll("\n", "<br/>"));
		$('.msg', t.shadowRoot).html(message);
		
		return new Promise(function(resolve) {
			$(".cancel,.close2", t.shadowRoot)	.on("click", e => { resolve(false);	$(".close", t.shadowRoot).trigger("click"); });

			t.shadowRoot.querySelector('dialog').showModal();
		});
	};
}

if (!customElements.get('nx-confirm-popup')) {
	customElements.define('nx-confirm-popup', nxConfirmPopup);
}

if (!customElements.get('nx-alert-popup')) {
	customElements.define("nx-alert-popup", nxAlertPopup);
}

